/* v8 ignore start */
import {Collection} from "@/lib/core/collection";
import {LottieTextJustify} from "@/lib/lottie/constants/lottieTextJustify";
import {LottieLayerType} from "@/lib/lottie/layers/lottieLayerType";
import {LottieVisualLayerModel} from "@/lib/lottie/layers/lottieVisualLayerModel";
import {LottieTextDataModel} from "@/lib/lottie/text/lottieTextDataModel";
import {LottieTextDocumentKeyFrameModel} from "@/lib/lottie/text/lottieTextDocumentKeyFrameModel";

// TODO: This value should not be present, currently it is necessary to adjust position to center
const CENTER_ADJUSTMENT_LINE_HEIGHT_COEFFICIENT = 1.2;

export type TRGB = [number, number, number];

export class LottieTextLayerModel extends LottieVisualLayerModel<LottieTextLayerModel.IJson> {
  public get name(): Maybe<string> {
    return this.json.nm;
  }

  public replaceWithAutoFit(text: string, maxWidth: number, maxHeight: number): this {
    const newFrames = this.keyFrames.map((keyFrame) => keyFrame.replaceTextWithAutoFit(text, maxWidth, maxHeight));
    const mainFrame = newFrames[0]; // TODO: Add multi-frame support if necessary upon further investigation

    const textDocument = mainFrame.lottieTextDocumentModel;
    const textHeight = textDocument.textHeight;
    const lineHeight = textDocument.lineHeight;
    const justify = textDocument.justify;

    // Currently only left & center justify are supported
    const positionX = justify === LottieTextJustify.Left ? 0 : maxWidth / 2;
    const positionY = (maxHeight - textHeight) / 2 + lineHeight * CENTER_ADJUSTMENT_LINE_HEIGHT_COEFFICIENT;

    // TODO: Maintain previous position animation related to position (can be animated before updated)
    return this.update({
      ks: this.transform
        .update({
          p: {a: 0, k: [positionX, positionY, 0], ix: 2},
        })
        .toObject(),
      t: {
        ...this.json.t,
        d: {k: newFrames.map((frame) => frame.toObject())},
      },
    });
  }

  public changeColor(color: TRGB) {
    const newFrames = this.keyFrames.map((keyFrame) => keyFrame.changeColor(color));

    return this.update({
      t: {
        ...this.json.t,
        d: {k: newFrames.map((frame) => frame.toObject())},
      },
    });
  }

  public get keyFrames(): Collection<LottieTextDocumentKeyFrameModel> {
    return new Collection(this.json.t.d.k.map((keyFrame) => new LottieTextDocumentKeyFrameModel(keyFrame)));
  }
}

export namespace LottieTextLayerModel {
  export interface IJson extends LottieVisualLayerModel.IJson {
    /** Layer type */
    ty: LottieLayerType.Text;

    /** Data */
    t: LottieTextDataModel.IJson;
  }
}
/* v8 ignore stop */
